import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

export default function TabBodyContainer({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      className="flex flex-1 flex-col items-center"
    >
      {value === index && (
        <Box className="flex w-full flex-1 p-0">
          <div className="h-full w-full flex-1 overflow-y-auto">{children}</div>
        </Box>
      )}
    </div>
  );
}

TabBodyContainer.propTypes = {
  children: PropTypes.any,
  value: PropTypes.number,
  index: PropTypes.number,
};
